module.exports = __webpack_public_path__ + "img/safe-background.73130b16.png";